import { render, staticRenderFns } from "./H5Content.vue?vue&type=template&id=4b790552&scoped=true"
import script from "./H5Content.vue?vue&type=script&lang=js"
export * from "./H5Content.vue?vue&type=script&lang=js"
import style0 from "./H5Content.vue?vue&type=style&index=0&id=4b790552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b790552",
  null
  
)

export default component.exports